module.exports = __webpack_public_path__ + "media/images/gift/noimage-0a167eafe48fea558fdb3fa979b6059f.png";